document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pincode-checker]').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-pincode-input]');
    var btn = wrapper.querySelector('[data-pincode-check]');
    var result = wrapper.querySelector('[data-pincode-result]');
    var note = wrapper.querySelector('[data-pincode-note]');
    var disclaimer = wrapper.querySelector('[data-pincode-disclaimer]');
    var header = wrapper.querySelector('[data-pincode-header]');
    var headerText = wrapper.querySelector('[data-pincode-header-text]');
    var resetBtn = wrapper.querySelector('[data-pincode-reset]');
    var row = wrapper.querySelector('.pincode-checker__row');

    if (!input || !btn || !result) return;

    // Processing = time to make/prepare the order (made-to-order)
    var processingDays = parseInt(wrapper.dataset.processingDays, 10);
    if (isNaN(processingDays)) processingDays = 5;
    // Transit = courier time after dispatch
    var transitMinDays = parseInt(wrapper.dataset.transitMinDays, 10);
    if (isNaN(transitMinDays)) transitMinDays = 5;
    var transitMaxDays = parseInt(wrapper.dataset.transitMaxDays, 10);
    if (isNaN(transitMaxDays)) transitMaxDays = 7;

    var successMsg = wrapper.dataset.successMsg;
    if (!successMsg || successMsg.indexOf('{start_date}') === -1) {
      successMsg = 'Get it by {start_date} to {end_date}';
    }
    var errorMsg = wrapper.dataset.errorMsg || 'Please enter a valid 6-digit pincode.';

    // Adds N days to a date (all days count, including Sundays)
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    function formatDate(date) {
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      return date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear();
    }

    function checkPincode() {
      var value = input.value.trim();
      var isValid = /^[1-9][0-9]{5}$/.test(value);

      if (!isValid) {
        result.textContent = errorMsg;
        result.className = 'pincode-checker__result pincode-checker__result--error';
        if (note) note.style.display = 'none';
        if (disclaimer) disclaimer.style.display = 'none';
        return;
      }

      var today = new Date();
      var startDate = addDays(today, processingDays + transitMinDays);
      var endDate = addDays(today, processingDays + transitMaxDays);

      var message = successMsg
        .replace('{start_date}', formatDate(startDate))
        .replace('{end_date}', formatDate(endDate));

      result.textContent = message;
      result.className = 'pincode-checker__result pincode-checker__result--success';
      if (note) note.style.display = 'block';
      if (disclaimer) disclaimer.style.display = 'block';
      if (header && headerText) {
        headerText.textContent = 'Delivery available at ' + value;
        header.style.display = 'flex';
      }
      if (row) row.style.display = 'none';
    }

    btn.addEventListener('click', checkPincode);

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        input.value = '';
        result.textContent = '';
        result.className = 'pincode-checker__result';
        if (note) note.style.display = 'none';
        if (disclaimer) disclaimer.style.display = 'none';
        if (header) header.style.display = 'none';
        if (row) row.style.display = 'flex';
        input.focus();
      });
    }

    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        checkPincode();
      }
    });

    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
    });
  });
});